var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"file-row-header sticky-top js-file-row-header gl-bg-default gl-px-2",attrs:{"title":_vm.path}},[_c('gl-truncate',{staticClass:"gl-font-bold",attrs:{"text":_vm.path,"position":"middle"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }